<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">
                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title">Update Webinar Info</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Webinar Date">
                                                <b-form-input id="WebinarDate" type="date"
                                                    v-model="form.WebinarDate"></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Webinar Time">
                                                <b-form-input id="WebinarTime" type="time"
                                                    v-model="form.WebinarTime"></b-form-input>
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Webinar Link (only Number)" label-for="WebinarLink">
                                                <b-form-input type="text" name="WebinarLink" autocomplete="WebinarLink"
                                                    v-model="form.WebinarLink">
                                                </b-form-input>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-1.5">
                                            <b-form-group label="Webinar is pre-recorded:" label-for="Zip">
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-1">
                                            <input class="checkbox" v-model="form.IsScottAbsent" type="checkbox" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group label="Webinar VimeoLink (only Number)" label-for="Phone1">
                                                <b-form-input type="text" name="WebinarVimeoLink"
                                                    v-model="form.WebinarVimeoLink">
                                                </b-form-input>
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-4"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-1.5">
                                            <b-form-group label="Webinar is available:" label-for="Zip">
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-1">
                                            <input class="checkbox" v-model="form.allow_webinar" type="checkbox" />
                                        </div>
                                        <div class="col-md-1.5">
                                            <b-form-group label="Video is available:" label-for="Zip">
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-1">
                                            <input class="checkbox" v-model="form.allow_webinar_video" type="checkbox" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-1.5">
                                            <b-form-group label="Webinar active?" label-for="Zip">
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-1">
                                            <input class="checkbox" v-model="form.isActive" type="checkbox" />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-2"></div>
                                        <div class="col-md-2 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span>Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--                                </form>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import router from '../router';
import moment from 'moment';

export default {
    name: 'edit_webinar',
    mixins: [validationMixin],
    data() {
        return {
            form: {
                id: '',
                WebinarDate: '',
                WebinarTime: '',
                WebinarLink: '',
                WebinarVimeoLink: '',
                IsScottAbsent: '',
                allow_webinar: '',
                allow_webinar_video: '',
                isActive: ''
            },

            isDisabled: false,
            readonly: true,
            member: {},
        };
    },
    validations: {
        form: {

            WebinarDate: {
                required,
            },
            Email: {
                required,
            },
            Address1: {
                required,
            },
            LastName: {
                required,
            },
            City: {
                required,
            },
            ReferralNotes: {
                required,
            },
        }
    },
    mounted() {
        this.form.id = this.$route.params.id;
        if (this.form.id && this.form.id !== 'undefined') {
            this.readonly = true;
        } else {
            this.readonly = false;
        }
        this.editWebinarinfo();
    },
    methods: {
        onSubmit() {
            // this.$v.form.$touch();
            // if (this.$v.form.$anyError) {
            //     return;
            // }
            this.isDisabled = true;
            API.updateWebinar(this.form,
                data => {
                    console.log(data);
                    this.isDisabled = false;
                    if (!this.form.id) {
                        if (data.status === 410) {
                            this.$showNotification(data, "error")
                        } else {
                            this.$showNotification(data, "success")

                            // this.$router.push({ name: 'webinarInformation/update' })
                        }
                    } else {
                        if (data.status === 200) {
                            // this.$showNotification(data, "success")
                            this.$router.push({ name: 'webinar_information' })
                        } else {
                            this.$showNotification({ message: 'Please try again.' }, "error")
                        }
                    }
                },
                err => {
                    this.$showNotification({ message: 'Failed system error' }, "error")
                }
            )
        },
        editWebinarinfo() {
            if (this.$route.params.webinarinfo != undefined) {
                this.member = this.$route.params.webinarinfo;
                this.form.id = this.member.WebinarID;
                this.form.WebinarDate = moment(this.member.WebinarDate).format('Y-MM-DD');
                this.form.WebinarTime = moment(this.member.WebinarTime).format('HH:mm');
                this.form.WebinarLink = this.member.WebinarLink;
                this.form.WebinarVimeoLink = this.member.WebinarVimeoLink;
                this.form.IsScottAbsent = (this.member.IsScottAbsent == 1) ? 1 : 0;
                this.form.allow_webinar = (this.member.allow_webinar == 1) ? 1 : 0;
                this.form.allow_webinar_video = (this.member.allow_webinar_video == 1) ? 1 : 0;
                this.form.isActive = (this.member.isActive == 1) ? 1 : 0;
            } else {
                router.push({ name: "webinar_information" })
            }
        },
    }, computed: {},
}
</script>
